import { COLORS, COLORS_DIM } from "@const/healthStatus.constants";
import { ThemeName } from "@dto/usersResponse.dto";
import { parseJSON } from "@dto/util/util";

/** localStorage key holding the JSON-encoded theme name */
export const THEME_NAME = 'theme-name';

/** Theme used until the user picks one */
export const THEME_DEFAULT: ThemeName = 'blue';

/** The only theme rendered with dark-mode colors */
export const THEME_DARK: ThemeName = 'dark';

/** Text and background colors substituted in dark mode */
export const DARK_MODE_COLORS = {
  color: '#ddd',
  bgColor: '#333',
  bgColorLight: '#444',
} as const;

export abstract class ThemeUtil {

  private static themeName: ThemeName;

  static onThemeChange: (name: ThemeName) => void;

  // static readonly NAMES = Object.keys(THEMES);
  //  {
  //   dark: 'dark',
  //   light: 'light'
  // } as const;

  static getThemeName() {
    ThemeUtil.themeName ??= parseJSON<ThemeName>(localStorage.getItem(THEME_NAME)) || THEME_DEFAULT;
    return ThemeUtil.themeName;
  }

  static isThemeStored(): boolean {
    return localStorage.getItem(THEME_NAME) !== null;
  }

  static persistThemeMode(name: ThemeName) {
    ThemeUtil.themeName = name;
    localStorage.setItem(THEME_NAME, JSON.stringify(name));
  }

  static setTheme(name: ThemeName) {
    ThemeUtil.persistThemeMode(name);
    ThemeUtil.onThemeChange?.(name);
  }

  static isDarkMode() {
    return ThemeUtil.getThemeName() === THEME_DARK;
  }

  static getHsColors() {
    return ThemeUtil.isDarkMode() ? COLORS_DIM : COLORS;
  }

  static getColor(lightColor?: string) {
    return ThemeUtil.isDarkMode() ? DARK_MODE_COLORS.color : lightColor;
  }

  static getBgColor(lightBgColor?: string) {
    return ThemeUtil.isDarkMode() ? DARK_MODE_COLORS.bgColor : lightBgColor;
  }

  static getBgColorLight() {
    return ThemeUtil.isDarkMode() ? DARK_MODE_COLORS.bgColorLight : undefined;
  }
}
